import { ReactNode, useCallback, useMemo, useRef, useState } from 'react';
import { ToastContext } from './ToastContext';
import { Toast } from './Toast';
import styles from './ToastProvider.module.scss';

const DISMISS_DELAY_MS = 4000;

interface ToastItem {
  id: string;
  message: string;
}

interface Props {
  children: ReactNode;
}

export function ToastProvider(props: Props) {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const nextID = useRef(0);

  const dismiss = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const show = useCallback(
    (message: string) => {
      const id = `${Date.now()}-${nextID.current++}`;
      setToasts((prev) => [...prev, { id, message }]);
      setTimeout(() => dismiss(id), DISMISS_DELAY_MS);
    },
    [dismiss],
  );

  const value = useMemo(() => ({ show }), [show]);

  return (
    <ToastContext.Provider value={value}>
      {props.children}
      <div className={styles['toast-list']}>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            onDismiss={() => dismiss(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
}
